import { InlineEmptyStateOnboarding, NoSearchResultsIllustration } from "@octopusdeploy/design-system-components";
import React from "react";
import { ExternalLinkSlugs } from "../ArgoCDConstants";
export const EmptyStateNoArgoCDApplications = () => (<InlineEmptyStateOnboarding illustration={"Custom"} image={<NoSearchResultsIllustration />} title={"No Argo CD applications found."} description={"We couldn't find any applications on this instance. If this is unexpected, it may be due to a permissions issue."} learnMore={{
        label: "Docs: Argo CD Instances",
        path: ExternalLinkSlugs.ArgoCDAuthenticationDocs,
    }}/>);
